export default "__VITE_ASSET__DApjRuXC__"